import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useGrammar } from "context/grammarContext";
import arrow from "../../assets/img/gifs/arrow_pt.gif";
import grammar from "../../assets/img/gifs/grammar_pt.gif";
import lambda from "../../assets/img/gifs/lambda-pt.gif";
import varenum from "../../assets/img/gifs/varenum_pt.gif";
export default function HowToUseGrammarDialog() {
  const {
    setActiveDialogHowToUseGrammar,
    isActiveDialogHowToUseGrammar,
  } = useGrammar();
  const handleClose = () => {
    setActiveDialogHowToUseGrammar(false);
  };

  return (
    <div>
      <Dialog
        open={isActiveDialogHowToUseGrammar}
        onClose={handleClose}
        style={{ height: "746px" }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Como Começar</DialogTitle>
        <DialogContent>
          <img src={lambda} alt="" id="infoPopup" />
        </DialogContent>
        <DialogContent>
          <img src={arrow} alt="" id="infoPopup" />
        </DialogContent>
        <DialogContent>
          <img src={varenum} alt="" id="infoPopup" />
        </DialogContent>
        <DialogContent>
          <img src={grammar} alt="" id="infoPopup" />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
